import React from "react";

import { css } from "@emotion/react";

import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import { CSS_MQ } from "../../../../../styles/breakpoints";
import { CSS_COLORS } from "../../../../../styles/styles-css-variables";
import { NoImageSvg } from "../../../../../assets";
import { ContentfulImage } from "../../../../../components/_shared-components/image-related/ContentfulImage";
import { FONTS, fontSize } from "../../../../../styles/fonts";
import { VariantPickerSharedProperties, VariantPickerVariation_Image } from "../utils";
import { InternalLinkOrButtonForPickers } from "./InternalLinkOrButtonForPickers";

export const ImagedVariantView: ReactTFC<{
  variation: Omit<VariantPickerVariation_Image, "tag">;
  action: VariantPickerSharedProperties["target"];
}> = props => {
  const labelStyles = [
    FONTS.SwarovskiFutura300,
    fontSize.x2,
    css`
      margin-top: 12px;
      margin-bottom: 6px;
      ${CSS_MQ.atLeastMd} {
        margin-top: 16px;
        margin-bottom: 30px;
      }
    `,
  ];

  return (
    <InternalLinkOrButtonForPickers action={props.action} attachStyles={linkStyles}>
      <div
        className={"image-wrapper"}
        css={css`
          position: relative;
          aspect-ratio: 1/1;

          --h1: 48px;
          ${CSS_MQ.atLeastMd} {
            --h1: 64px;
          }

          height: var(--h1);
        `}
      >
        {props.variation.image ? (
          <ContentfulImage
            assetId={undefined}
            className={"image"}
            contentfulLink={{
              url: props.variation.image.asset,
              requestedWidth: 200,
              noTransparentBackground: false,
            }}
            attachPictureStyles={css`
              display: flex;
            `}
            css={imgStyle}
          />
        ) : (
          <NoImageSvg className={"image"} css={imgStyle} strokeWidth={1} />
        )}
      </div>

      <span css={labelStyles}>{props.variation.name}</span>
    </InternalLinkOrButtonForPickers>
  );
};

const linkStyles = css`
  position: relative;
  height: 100%;

  display: grid;
  justify-items: center;

  background: white;

  text-decoration: none;
  color: inherit;

  .active > & .image-wrapper {
    &:after {
      --b: 3px;
      --r: 4px;

      --size: calc(100% + 2 * var(--r));
      --shift: calc(-1 * var(--b) + -1 * var(--r));

      position: absolute;
      content: "";

      width: var(--size);
      height: var(--size);

      top: var(--shift);
      left: var(--shift);

      border: 2px solid ${CSS_COLORS.Green};
      border-width: var(--b);
      border-radius: 100%;
    }
  }

  .disabled > & {
    cursor: not-allowed;
    opacity: 0.3;
  }

  &:focus {
    outline: none;
  }
`;

const imgStyle = css`
  max-width: 100%;

  height: var(--h1);
`;
